import React, { useEffect, useRef, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";
const DivisibilityDetective = () => {
  const [number, setNumber] = useState(240);
  const [selected, setSelected] = useState([]);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('#fff');

  const correctSound = useRef(null);
  const wrongSound = useRef(null);

  const options = [2, 4, 5, 6, 8, 10, 'None'];

  const generateNumber = () => {
    const newNumber = Math.floor(Math.random() * 500) + 100;
    setNumber(newNumber);
    setSelected([]);
    setFeedback('');
    setFeedbackColor('#fff');
  };

  const toggleOption = (value) => {
    setSelected((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  const checkAnswers = () => {
    const divisors = options.filter(
      (v) => typeof v === 'number' && number % v === 0
    ).sort();

    const correct = divisors.length === 0 ? ['None'] : divisors;

    const picked = [...selected].sort();

    const isCorrect = JSON.stringify(picked) === JSON.stringify(correct);

    if (isCorrect) {
      setFeedback("🌟 Excellent! You're a Divisibility Pro!");
      setFeedbackColor('#2ECC40');
      correctSound.current.play();
            const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      
    } else {
      setFeedback(`❌ Try Again! Correct: ${correct.join(', ')}`);
      setFeedbackColor('#FF4136');
      wrongSound.current.play();
    }

    setTimeout(generateNumber, 1500);
  };

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: 'linear-gradient(#a6fbf5 ,rgb(197, 238, 114))',
      color: '#fff',
      textAlign: 'center',
      padding: '40px',
      minHeight: '100vh',
    },
    h1: {
      fontSize: '2.5rem',
      marginBottom: '10px',
    },
    number: {
      fontSize: '4rem',
      color: '#FFDC00',
      margin: '30px 0 10px',
    },
    option: (active) => ({
      display: 'inline-block',
      background: active ? '#FF851B' : '#39CCCC',
      color: active ? 'white' : '#000',
      fontSize: '1.5rem',
      padding: '10px 20px',
      borderRadius: '10px',
      margin: '10px',
      cursor: 'pointer',
      userSelect: 'none',
      transition: '0.2s ease',
    }),
    button: {
      fontSize: '1.5rem',
      marginTop: '20px',
      padding: '12px 25px',
      background: '#2ECC40',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
      color: '#fff',
    },
    feedback: {
      fontSize: '1.8rem',
      marginTop: '20px',
      height: '40px',
      color: feedbackColor,
    },
  };

  useEffect(() => {
    generateNumber();
  }, []);

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>🕵️ Divisibility Detective</h1>
      <p>Which numbers divide <span style={styles.number}>{number}</span> exactly?</p>

      <div>
        {options.map((val) => (
          <div
            key={val}
            onClick={() => toggleOption(val)}
            style={styles.option(selected.includes(val))}
          >
            {val}
          </div>
        ))}
      </div>

      <button style={styles.button} onClick={checkAnswers}>✅ Check</button>
      <div style={styles.feedback}>{feedback}</div>

      <audio ref={correctSound} src="https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg" />
      <audio ref={wrongSound} src="https://actions.google.com/sounds/v1/cartoon/cartoon_boing.ogg" />
    </div>
  );
};

export default DivisibilityDetective;
